import React from 'react'

const Faq = () => {
  return (
    <>
    
   {/* TODO : FAQs */}
<section className="ax-faq-sec-section">
  <div className="ax-faq-sec-container">
    <h2 className="ax-faq-sec-title">
      <span className="ax-faq-sec-orange">F</span>AQs
    </h2>
    <div className="ax-faq-sec-list">
      <details className="ax-faq-sec-item">
        <summary className="ax-faq-sec-question">
          How does E-commerce software work?
          <span className="ax-faq-sec-icon" />
        </summary>
        <div className="ax-faq-sec-answer">E-commerce software is an amazing tool that manages all online store processes, helps E-commerce owners to manage inventory, add or remove products, compute taxes, process payments, and fulfill orders, among many others. It provides everything needed to run a retail site, effectively simplifying online store management.
        </div>
      </details>
      <details className="ax-faq-sec-item">
        <summary className="ax-faq-sec-question">
          Why Is E-commerce Needed For Any Business?
          <span className="ax-faq-sec-icon" />
        </summary>
        <div className="ax-faq-sec-answer">E-commerce has gained much popularity nowadays because it offers businesses a whole range of opportunities ranging from marketing opportunities to increasing the range of products that helps to generate sales. AxeSell provides you an optimized and well-created e-store that you can easily create and achieve the goals and also offer the customers round-the-clock support services.
        </div>
      </details>
      <details className="ax-faq-sec-item">
        <summary className="ax-faq-sec-question">How To Create An Impressive E-commerce Store/Website?
          <span className="ax-faq-sec-icon" />
        </summary>
        <div className="ax-faq-sec-answer"> The beauty of a site lies in its mode of operation and being user-friendly. Make sure your site is fast, secure, easy to use, looking professional and attractive. In addition, make sure that you are able to fulfill orders very quickly without any delay. AxSell provides you all these facilities in one place, for this you do not have to work very hard.
        </div>
      </details>
      <details className="ax-faq-sec-item">
        <summary className="ax-faq-sec-question">Is there a limit on the size of my product or customer database?
          <span className="ax-faq-sec-icon" />
        </summary>
        <div className="ax-faq-sec-answer">  No, as there is no size limit. The biggest advantage of having an online store is that you can add unlimited products and catalogs and at the same time you can increase your customer base as needed.
        </div>
      </details>
      <details className="ax-faq-sec-item">
        <summary className="ax-faq-sec-question">How many domains can I use with one license?
          <span className="ax-faq-sec-icon" />
        </summary>
        <div className="ax-faq-sec-answer"> Only one Domain you can use with one license.
        </div>
      </details>
      <details className="ax-faq-sec-item">
        <summary className="ax-faq-sec-question">Do I have to pay a separate fee for this?
          <span className="ax-faq-sec-icon" />
        </summary>
        <div className="ax-faq-sec-answer"> No, you do not have to pay a separate fee, only you have to pay Rs 3500 at the time of hosting the renewal.
        </div>
      </details>
    </div>
  </div>
</section>

    </>
  )
}

export default Faq